const defaultSelector = {
  native: {
    CAROUSEL_SWIPER_SELECTOR: 'js-carousel-swiper-native'
  },
  component: {
    CAROUSEL_SWIPER_SELECTOR: 'js-carousel-swiper-component'
  },
  CAROUSEL_SWIPER_PREV_SELECTOR: '.js-carousel-prev',
  CAROUSEL_SWIPER_NEXT_SELECTOR: '.js-carousel-next',
  PAGINATION_SELECTOR: '.js-carousel-pagination',
  SCROLL_BAR_SELECTOR: '.js-carousel-scrollbar'
}

const getOptionsByType = (el, options = {}, config, type) => {
  const { navigation, pagination, scrollbar } = options

  const defaultOptions = {
    direction: options.direction || 'horizontal',
    lazy: options.lazy || true,
    zoom: config.zoom || false,
    freeMode: {
      enabled: config.freeMode || false
    },
    mousewheel: config.mousewheel || false,
    keyboard: {
      enabled: config.keyboard || false,
      onlyInViewport: config.onlyInViewport || true
    }
  }

  if (type === 'native') {
    const navEl = {
      prevEl: defaultSelector.CAROUSEL_SWIPER_PREV_SELECTOR,
      nextEl: defaultSelector.CAROUSEL_SWIPER_NEXT_SELECTOR
    }
    const paginationEl = defaultSelector.PAGINATION_SELECTOR
    const scrollbarEl = defaultSelector.SCROLL_BAR_SELECTOR

    return {
      ...options,
      navigation: config.navigation && { ...navigation, ...navEl },
      pagination: config.pagination && { ...pagination, el: paginationEl },
      scrollbar: config.scrollbar && { ...scrollbar, el: scrollbarEl },
      ...defaultOptions
    }
  } else {
    const navEl = {
      prevEl: el.querySelector(defaultSelector.CAROUSEL_SWIPER_PREV_SELECTOR),
      nextEl: el.querySelector(defaultSelector.CAROUSEL_SWIPER_NEXT_SELECTOR)
    }

    const paginationEl = el.querySelector(defaultSelector.PAGINATION_SELECTOR)
    const scrollbarEl = el.querySelector(defaultSelector.SCROLL_BAR_SELECTOR)

    let thumbnail = {}

    if (config.thumbnail) {
      const thumbnailEl = document.querySelector(config.thumbnail)

      thumbnail = {
        thumbs: {
          swiper: thumbnailEl,
          multipleActiveThumbs: false
        }
      }
    }

    return {
      ...options,
      navigation: config.navigation && { ...navigation, ...navEl },
      pagination: config.pagination && { ...pagination, el: paginationEl },
      scrollbar: config.scrollbar && { ...scrollbar, el: scrollbarEl },
      ...defaultOptions,
      ...thumbnail
    }
  }
}

const getSelector = (el, defaultSelectorEl = null) => {
  return el.getAttribute('data-selector') || defaultSelectorEl
}

const getType = (el) => {
  return el.getAttribute('data-type') || null
}

export {
  defaultSelector,
  getOptionsByType,
  getSelector,
  getType
}
